import React from 'react';
import { Button, ButtonProps as AntButtonProps } from 'antd';
import styled from 'styled-components';

type CustomButtonProps = {
	fullWidth?: boolean;
	disablePaddings?: boolean;
};

type MpButtonProps = React.PropsWithChildren<unknown> & AntButtonProps & CustomButtonProps;

export const MpButton = styled(({ children, ...props }: MpButtonProps) => <Button {...props}>{children}</Button>)`
	font-size: 16px;
	@media (max-width: 575px) {
		border-radius: 9px;
	}
	${props => props.fullWidth && `min-width: 100%`}
	${props => props.disablePaddings && `padding: 0`}
`;
